module.exports = "<div class=\"ml-0\" style=\"position: relative;\" >\n    <ContentLoader height=\"120\" :primaryColor=\"dtPalette['grey-3']\" >\n        <rect x=\"0\" y=\"0\" rx=\"3\" ry=\"3\" width=\"100%\" height=\"100%\" />\n    </ContentLoader>\n    <ContentLoader style=\"position: absolute;top:0;left:0\" :primaryColor=\"dtPalette['grey-4']\" >\n        <rect x=\"40\" y=\"40\" rx=\"4\" ry=\"4\" width=\"60%\" height=\"15%\" />\n    </ContentLoader>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/containers/ticket/loaders/ticket-list-filters-loader/template.html
// module id = oK9d
// module chunks = 0